import { Text, TextType } from 'ui-components/components/text';

import style from './settings-page-title.module.less';

import type { PrimitiveType } from 'intl-messageformat';
import type React from 'react';
import type { RequiredTextValue } from 'ui-components/components/text/text-types';

type SettingsPageTitleProps = {
  value: RequiredTextValue;
  formattedMessageValues?: Record<string, PrimitiveType>;
};

export const SettingsPageTitle: React.FC<SettingsPageTitleProps> = ({ value, formattedMessageValues }) => {
  return (
    <Text className={style['settings-page-title']} formattedMessageValues={formattedMessageValues} textType={TextType.H1} value={value} />
  );
};
